import { authenticatedFetch } from "../utils/api";

export const fetchTherapists = async () => {
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL}/api/therapists`);
  if (!response.ok) {
    throw new Error('Failed to fetch therapists');
  }
  return response.json();
};

export const fetchPrimaryTherapist = async (): Promise<{
  therapist: { id: string; name: string; imageUrl?: string; specialties: Array<{ id: string; name: string }> };
  hasUpcomingSession: boolean;
  nudge?: string;
} | null> => {
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL}/api/user/primary-therapist`);
  if (response.status === 404) return null;
  if (!response.ok) throw new Error('Failed to fetch primary therapist');
  return response.json();
};
